export default ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
    return {
        search: (searchRequestDTO) => {
            return JsonRPCService.send('pc', 'gateway/search', 'search', [searchRequestDTO]);
        },

        searchPartial: (searchRequestDTO) => {
            return JsonRPCService.send('pc', 'gateway/search', 'searchPartial', [searchRequestDTO]);
        },
        searchVehicleByVIN: (searchParam) => {
            return JsonRPCService.send('pc', 'gateway/search', 'searchVehicleByVIN', [searchParam]);
        },
        searchVehicleByLicense: (searchParam, country) => {
            return JsonRPCService.send('pc', 'gateway/search', 'searchVehicleByLicense', [searchParam, country]);
        },
        validateNSCVIN: (searchParam) => {
            return JsonRPCService.send('pc', 'gateway/search', 'validateNSCVIN', [searchParam]);
        },
        validateRRDICode: (searchParam) => {
            return JsonRPCService.send('pc', 'gateway/search', 'validateRRDICode', [searchParam]);
        }
    };
}];